import { useTranslation } from 'react-i18next';

export const SUPPORTED_LANGUAGES = ['enUS', 'elGR'];

const SHORT_TO_FULL = {
  en: 'enUS',
  el: 'elGR',
};

export const toShortCode = (lng) => (lng && lng.startsWith('el') ? 'el' : 'en');

export default function useLanguage() {
  const { i18n } = useTranslation();

  const language = i18n.resolvedLanguage || i18n.language || 'enUS';
  const shortLanguage = toShortCode(language);

  const setLanguage = (next) => {
    const target = SHORT_TO_FULL[next] || next;
    if (!SUPPORTED_LANGUAGES.includes(target)) return;
    if (target === language) return;
    i18n.changeLanguage(target);
  };

  return { language, shortLanguage, setLanguage };
}
